"use client"

import { signIn } from "next-auth/react"
import { Button } from "@/components/ui/button"

export function LoginButton() {
  const handleSignIn = () => {
    // Set cookie to indicate this is a bookkeeper login
    document.cookie = "auth_user_type=bookkeeper; path=/; max-age=300"; // 5 min expiry
    // Auth callback page will handle routing based on actual user type
    signIn("google", { callbackUrl: "/auth/callback" })
  }

  return (
    <Button onClick={handleSignIn} variant="default">
      Sign in with Google
    </Button>
  )
}
